import { ISystemInfo } from "@interfaces/api/system";
import { getPlatformVersion } from "@services/practitionersList/Practitioners";
import { useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";

const usePlatformInfo = () => {
    const [ info, setInfo ] = useState<ISystemInfo | null>(null);
    const [ error, setError ] = useState<unknown | null>(null);
    const [ isLoading, setIsLoading ] = useState<boolean>(false);
    const [ hasLoggedId, setHasLoggedIn ] = useState<boolean>(false);

    const [ cookies ] = useCookies([ 'authToken', 'refreshToken', 'user']);

    const loadData = useCallback(async() => {
        try
        {
            setIsLoading(true);
            const resp = await getPlatformVersion();
            setInfo(resp);
            setError(null);
        }
        catch(err)
        {
            console.error("getPlatformVersion", err);
            setError(err);
            setInfo(null);
        }
        finally
        { 
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if(!hasLoggedId) return;

        const minutes = 15;
        const miliseconds = minutes * 60 * 1000;

        console.debug(`Check for updates every ${miliseconds} miliseconds, ${minutes} minutes`);

        loadData();
        const interval = setInterval(() => {
            loadData();
        }, miliseconds);

        return () => {
            clearInterval(interval);
        };
    }, [loadData, hasLoggedId]);

    useEffect(() => {
        const temp = cookies && cookies["authToken"] !== undefined && cookies["authToken"] !== null && 
            cookies["user"] !== undefined && cookies["user"] !== null ;

        console.debug("User has logged in?", temp);
        setHasLoggedIn(temp);
    }, [ cookies ]);

    return { info, error, isLoading, realoadData: loadData };
};

export default usePlatformInfo;
